"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfrastructureV1 = void 0;
var InfrastructureV1 = /** @class */ (function () {
    function InfrastructureV1(data) {
        this.apiGateway = data.apiGateway || null;
        this.imageStorage = data.imageStorage || null;
        this.xGraph = data.xGraph || null;
    }
    InfrastructureV1.prototype.getApiGateway = function () {
        return this.apiGateway;
    };
    InfrastructureV1.prototype.getXgraph = function () {
        return this.xGraph;
    };
    InfrastructureV1.prototype.getImageStorage = function () {
        return this.imageStorage;
    };
    return InfrastructureV1;
}());
exports.InfrastructureV1 = InfrastructureV1;
//# sourceMappingURL=infrastructure.js.map